import '../style/bread-crumb.scss'
export default {
  functional: true,
  render (h, context) {
    const [$slots] = context.children
    const props = context.props
    const leng = props.breadCrumbData.length
    const renderInner = () => {
      if (!leng) {
        return null
      }
      return props.breadCrumbData.map(item => {
        return $slots.crumbItem({
          item,
          type: 'bread-item'
        })
      })
    }
    const inner = renderInner()
    const label = props.breadCrumbLabel
    return <div class='kye-area-bread-crumb'>
      {
        inner
      }
      <div class='label'>{label}</div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/components/bread-crumb.js